import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { LazyModulesService } from './lazy-modules.service';
import { MODULE_INITIALIZER } from './tokens';

export function moduleInitializersFactory(
  lazyModuleService: LazyModulesService,
  moduleInitializerFunctions: (() => any)[],
): () => any {
  const factoryFunction = () => {
    return Promise.all(lazyModuleService.runModuleInitializerFunctions(moduleInitializerFunctions)).catch((error) => {
      console.error('MODULE_INITIALIZER promise was rejected during app initialization.', error);
      throw error;
    });
  };
  return factoryFunction;
}

@NgModule({})
export class LazyLoadingModule {
  static forRoot(): ModuleWithProviders<LazyLoadingModule> {
    return {
      ngModule: LazyLoadingModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = moduleInitializersFactory(
            inject(LazyModulesService),
            inject(MODULE_INITIALIZER, { optional: true }) ?? []
          );

          return initializerFn();
        }),
      ],
    };
  }
}
